import { bl_login_subject_to_employee_link_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class LoginSubjectToEmployeeLinkContainerModel extends BaseContainerModel {
    bl_login_subject_to_employee_link: bl_login_subject_to_employee_link_RowClass = new bl_login_subject_to_employee_link_RowClass();
}
